import React from 'react';
import { UnemploymentAssistanceDetails } from '~/scenes';
import { Stack } from '../stackNavigation';

export const UnemploymentAssistanceNavigation = (
  <Stack.Group>
    <Stack.Screen
      name="MarisaServicos_UnemploymentAssistanceDetails"
      component={UnemploymentAssistanceDetails}
    />
  </Stack.Group>
);
